module.exports = __webpack_public_path__ + "img/left-boy1.e033fca5.svg";